import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyToSign } from '@monorepo/client-types';
import {
  designTokens,
  Statistic,
  TableCell,
  TableRow,
  Typography,
} from '@monorepo/nova-ui';

interface Props {
  amountInCurrency: number;
  currency: string;
  isMobile: boolean;
}

const InvoiceConclusion: FunctionComponent<Props> = ({
  amountInCurrency,
  currency,
  isMobile,
}) => {
  const { t } = useTranslation(['common']);
  return (
    <TableRow>
      <TableCell>
        <Typography variant="caption" color="text.secondary">
          {t('common:total')}
        </Typography>
      </TableCell>
      <TableCell colSpan={isMobile ? 2 : 3}></TableCell>
      <TableCell align="right">
        <Typography
          variant="subtitle2"
          fontWeight={designTokens.typography.fontWeights.semiBold}
        >
          <Statistic
            prefix={CurrencyToSign[currency]}
            value={amountInCurrency}
            precision={2}
            align="right"
          />
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default InvoiceConclusion;
